define([
	"dojo/_base/declare",
	"csi",
	"csi/resolver",
	"csi/xml",
	"Apparel/NewStyle"
], function(declare,csi,resolver,xml,NewStyle) {

	var	_addHierarchyDefault = function(view, url, id) {
		if (url != csi.EMPTY_URL) {
			view.addDefaultValue(id, url);
		}
	};
	
	return declare(NewStyle, {
		onCreatePopupParams: function(/*Object*/params) {
			// summary: allow controller to add parameters to popup view
			params.bAddHierarchyFields = true;
		},
		
		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set form default values
			var	fd = this.m_formData;
			var	pp = this.getParent();
			var bp = resolver.resolveNode(pp.__Parent__, true, this.m_cache);
			
			view.addDefaultValue(xml.ATTR_NAME, pp.$Name);
			
			_addHierarchyDefault(view, bp.BPCollection, "Collection");
			_addHierarchyDefault(view, bp.BPCategory2, "Category2");
			_addHierarchyDefault(view, bp.BPCategory1, "Category1");
			_addHierarchyDefault(view, bp.BPSeason, "ParentSeason");

			this.inherited(arguments);
		},

		toWriter: function() {
			var call = this.inherited(arguments);

			var collection = this.getFormData().getFieldValue("Collection");

			this.m_writer.changeNode(collection).changeAttribute("Hierarchy", xml.ATTR_REF, this.m_urlNode, true);

			return call;
		}
	});
});